/* eslint-disable no-param-reassign */

import InViewSrcset from '@Core/components/inViewSrcset';
import { reloadScripts, accessibeHelpers } from '@Utility';
import { breakpoints } from '@Front/constants';
import { classes, selectors } from './config';
import EVENT_NAMES from '../../eventNames';
import Events from './events';

export default class PreviewPanel {
  vehicleElements = new Map();

  container;
  vehiclesContainer;
  vehiclesList;
  minimizeBtn;
  maximizeBtn;
  navigationBtns;
  clearAllBtn;

  constructor() {
    this.container = document.querySelector(selectors.container);
    this.vehiclesContainer = this.container.querySelector(
      selectors.vehiclesContainer,
    );
    this.vehiclesList = this.container.querySelector(selectors.vehiclesList);
    this.headerEl = this.container.querySelector(selectors.header);
    this.minimizeBtn = this.container.querySelector(selectors.minimizeBtn);
    this.maximizeBtn = this.container.querySelector(selectors.maximizeBtn);
    this.mobileNavigateBtn = this.container.querySelector(
      selectors.mobileNavigateBtn,
    );
    this.mobileNavigateBtnText = this.mobileNavigateBtn.querySelector(
      selectors.mobileNavigateBtnText,
    );
    this.navigationBtns = this.container.querySelectorAll(
      selectors.navigationBtn,
    );
    this.clearAllBtns = this.container.querySelectorAll(selectors.clearAllBtn);
    this.attachListeners();
  }

  attachListeners() {
    window.addEventListener(EVENT_NAMES.READY, () => {
      reloadScripts(document, [InViewSrcset]);
    });

    this.minimizeBtn.addEventListener('click', () => {
      this.minimize();
    });

    this.maximizeBtn.addEventListener('click', () => {
      this.maximize();
    });

    this.clearAllBtns.forEach((button) => {
      button.addEventListener('click', () => {
        this.container.dispatchEvent(Events.ClearAll);
      });
    });

    window
      .matchMedia(`(max-width: ${breakpoints['break-3']}px)`)
      .addEventListener('change', () => {
        this.minimize();
      });
  }

  isActive() {
    return this.container.dataset.active === 'true';
  }

  show() {
    this.container.dataset.active = true;
    this.container.ariaHidden = false;
  }

  hide() {
    this.container.dataset.active = false;
    this.container.ariaHidden = true;
  }

  minimize() {
    this.container.dataset.minimized = true;

    try {
      accessibeHelpers.revertAccessibeVerticalPosition();
    } catch (err) {
      console.error(err);
    }

    window.dispatchEvent(Events.Minimized);
  }

  maximize() {
    this.container.dataset.minimized = false;

    try {
      accessibeHelpers.setAccessibeVerticalPosition('50%');
    } catch (err) {
      console.error(err);
    }

    window.dispatchEvent(Events.Maximized);
  }

  setTitle(text) {
    this.headerEl.textContent = text;
    this.mobileNavigateBtnText.textContent = text;
  }

  addVehicle(vehicle) {
    const listEl = document.createElement('li');
    const className = classes.vehicle;

    listEl.classList.add(className);
    listEl.dataset.stockId = vehicle.stockId;
    listEl.append(vehicle.previewCard);
    this.vehiclesList.prepend(listEl);
    reloadScripts(document, [InViewSrcset]);

    this.vehicleElements.set(vehicle.stockId, listEl);
  }

  removeVehicle(stockId) {
    const listEl = this.vehicleElements.get(stockId);

    listEl.remove();
    this.vehicleElements.delete(stockId);
  }

  setNavigationUrl(url) {
    this.navigationBtns.forEach((button) => {
      button.querySelector('a').href = url;
    });
  }

  setNavigationText(text) {
    this.navigationBtns.forEach((button) => {
      button.querySelector('a .btn__text').textContent = text;
    });
  }

  reset() {
    this.hide();
    this.vehiclesList.innerHTML = '';
  }

  on(event, callback) {
    this.container.addEventListener(event, callback);
  }
}
